
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/gpt-4-paper",
      function () {
        return require("private-next-pages/search/gpt-4-paper.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/gpt-4-paper"])
      });
    }
  